import SectionHead from "./SectionHead";
import { hotRank } from "@/mocks/homeContent";

export default function HotRank() {
  return (
    <section id="hot" className="w-full scroll-mt-24">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-16 md:px-6 md:py-24">
        <div className="flex w-full flex-col items-start justify-between gap-5 md:flex-row md:items-end">
          <SectionHead
            eyebrow="HOT BOARD · 常翻热榜"
            title="这段时间被翻最多的"
            desc="按回翻热度给档目排个队，热门爆料的新料老料都在上面，进来先看这份，基本不会扑空。"
          />
          <span className="hidden shrink-0 items-center gap-1.5 text-[13px] text-[#8a7a5c] md:inline-flex">
            <i className="ri-time-line text-[15px]" aria-hidden="true" />
            榜单每小时自动更新
          </span>
        </div>

        <div className="mt-10 overflow-hidden rounded-xl border border-[#ded2bb] bg-white">
          {hotRank.map((item, i) => (
            <a
              key={item.rank}
              href="#shelf"
              className={`group flex w-full flex-col gap-3 px-5 py-5 transition-colors hover:bg-[#f7f1e3] md:flex-row md:items-center md:gap-6 md:px-7 ${
                i !== hotRank.length - 1 ? 'border-b border-[#efe6d4]' : ''
              }`}
            >
              <span
                className={`font-editorial w-fit text-[28px] italic leading-none md:w-12 ${
                  item.rank <= 3 ? 'text-[#c8962f]' : 'text-[#c9b892]'
                }`}
              >
                {String(item.rank).padStart(2, '0')}
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <h3 className="text-[16px] font-bold text-[#241f18] md:text-[17px]">
                    {item.title}
                  </h3>
                  <span className="whitespace-nowrap rounded-md bg-[#f3e9d2] px-2 py-0.5 text-[11px] font-semibold text-[#a1762f]">
                    {item.tag}
                  </span>
                </div>
                <p className="mt-1 hidden text-[13px] text-[#6d6149] sm:block">{item.desc}</p>
              </div>
              <div className="flex shrink-0 items-center gap-4 md:flex-col md:items-end md:gap-1">
                <span className="flex items-center gap-1 text-[13px] font-semibold text-[#a1762f]">
                  <i className="ri-fire-fill text-[14px]" aria-hidden="true" />
                  {item.heat}
                </span>
                <span className="text-[12px] text-[#a19680]">{item.update}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}